module.exports = require("../dist/plugins/local-storage");